export default __webpack_public_path__ + "static/media/15.9611e658.jpg";